import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AppBannerContainer from '../AppBannerContainer';
import MobileInviteBannerContainer from '../MobileInviteBannerContainer';
import { isCondensedMobileLayoutActive } from '../../utils/pages/homepage';
import { hasVariant } from '../../selectors/configSelectors';
import { MVT_1068 } from '../../flags/experiments';

function MobileBanners({ isMgmBanner, inviteLink, page, showCondensedMobileLayout }) {
  if (isMgmBanner && !!inviteLink) {
    return <MobileInviteBannerContainer />;
  }

  return !showCondensedMobileLayout && <AppBannerContainer page={page} />;
}

MobileBanners.propTypes = {
  isMgmBanner: PropTypes.bool.isRequired,
  inviteLink: PropTypes.string,
  page: PropTypes.string.isRequired,
  showCondensedMobileLayout: PropTypes.bool,
};

MobileBanners.defaultProps = {
  inviteLink: undefined,
  showCondensedMobileLayout: false,
};

export default connect((state) => ({
  isMgmBanner: hasVariant(state, MVT_1068, 'mgm_banner'),
  inviteLink: state.user.roovite.link,
  showCondensedMobileLayout: isCondensedMobileLayoutActive(state),
}))(MobileBanners);
